import Link from "next/link";
import { useRouter } from "next/router";
import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { BANNER_COOKIE_NAME, getCookie, setCookie } from "../../common/auth";
import {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
} from "../../redux/action/confirm";
import {
  clearBasketsAction,
  deleteBasketsAction,
  fetchBasketsAction,
  initBaskets,
  insertBasketsAction,
} from "../../redux/action/baskets";
import { updateProductCategory } from "../../redux/action/productFiltersAction";
import { isLoaded, isLoading } from "../../redux/action/loading";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css/pagination";
import { fetchDummyList } from "../../redux/action/dummy";
import { PageRouter } from "../../common/pageRouter";
import UserFloating from "../floating/user";
import MobileSearch from "./mobileSearch/MobileSearch";
import {
  clearCart,
  decreaseCnt,
  deleteFromCart,
  increaseCnt,
} from "../../redux/action/cart";
import { fetchSiteInfo } from "../../redux/action/siteInfo";
import ProceedingMenuBadge from "../../common/badge/proceedingMenuBadge";
import StripeBanner from "./header/StripeBanner";
import FirstHeader from "./header/FirstHeader";
import SecondHeader from "./header/SecondHeader";
import { initUserInfo } from "../../redux/action/userInfo";
import ImageBanner from "@components/layout/header/ImageBanner";
import { useAuthHandler } from "@hook/header/useAuthHandler";
import { useNotiSettingHandler } from "@hook/header/useNotiSettingHandler";
import CategoryCustomizingMenu from "@components/layout/header/menu/CategoryCustomizingMenu";
import styled from "styled-components";
import CategoryMenu from "@components/layout/header/menu/CategoryMenu";
import { useBannerStore } from "@store/useBannerStore";

export const StyledMegaMenu = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: ${({ $left }) => `${$left}px`};
  background-color: #ffffff;
  z-index: 100;
  gap: 24px;
  border: 1px solid #e0e0e0;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  ${({ $categoriesLength }) => {
    if (typeof $categoriesLength === "number") {
      const basePercent = 12;
      const minPercent = 70;
      const maxPercent = 100;

      const computedPercent = Math.min(
        Math.max($categoriesLength * basePercent, minPercent),
        maxPercent
      );

      return `
        width: ${computedPercent}%;
        border: none;
      `;
    }

    // 기본 width는 px로 지정, 이때는 full border 스타일 포함
    return `
      width: 1110px;
 
    `;
  }}
`;

// 부모 li가 hover 상태일 때 보여주기
export const MenuItemWithDropdown = styled.li`
  position: relative;

  &:hover ${StyledMegaMenu} {
    display: flex;
  }
`;

SwiperCore.use([Navigation, Pagination]);

const Header = ({
  logo,
  show,
  totalCartItems,
  toggleClick,
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  userInfo,
  deleteBasketsAction,
  insertBasketsAction,
  fetchBasketsAction,
  clearBasketsAction,
  basketItems,
  basketsCount,
  initBaskets,
  deleteFromCart,
  updateProductCategory,
  productFilters,
  loading,
  userCoupons,
  isLoaded,
  isLoading,
  fetchDummyList,
  dummyList,
  vp,
  cartItems,
  clearCart,
  decreaseCnt,
  increaseCnt,
  fetchSiteInfo,
  siteInfo,
  initUserInfo,
  banners,
}) => {
  const router = useRouter();
  const [isToggled, setToggled] = useState(false);
  const [scroll, setScroll] = useState(0);
  const [btnText, setBtnText] = useState("");
  const [isUser, setIsUser] = useState(false);
  const [decideUrl, setDecideUrl] = useState("");
  const categoriRef = useRef(null);
  const [notificationPermission, setNotificationPermission] = useState("");
  const [awardIdx, setAwardIdx] = useState(0);
  const [menus, setMenus] = useState(null);
  const [searchToggled, setSearchToggled] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const scrollSearchBtnRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  //배너 데이터
  const {
    bannerList,
    headerMenu,
    mainAward,
    mainStripe,
    mainImageStripe,
    lnbEsg,
    lnbCsboard,
    lnbSmallPrint,
  } = useBannerStore((s) => s);

  // 유효성 체크
  const hasMainStripe = Array.isArray(mainStripe) && mainStripe.length > 0;
  const hasMainImageStripe =
    Array.isArray(mainImageStripe) && mainImageStripe.length > 0;

  // 모바일 여부 확인
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const handleClose = () => {
    // 1일 후 만료되는 쿠키 설정
    const expiryDate = new Date();

    // 당일 밤 11:59:59로 설정
    expiryDate.setHours(23, 59, 59, 999);

    // 현재 시간 확인
    const now = new Date();
    if (now > expiryDate) {
      // 이미 당일 밤 11:59:59를 지났다면 다음날 밤 11:59:59로 설정
      expiryDate.setDate(expiryDate.getDate() + 1);
    }

    // 쿠키를 "true"로 설정하여 배너 숨김 유지
    setCookie(BANNER_COOKIE_NAME, "true", {
      path: "/",
      expires: expiryDate,
    });
  };

  const onClickSearch = () => {
    setSearchToggled(!searchToggled);
  };

  const hadleClickOutSide = (e) => {
    if (categoriRef.current) {
      if (!categoriRef.current?.contains(e.target)) {
        categoriRef.current.children[1].style.visibility = "hidden";
        categoriRef.current.children[1].style.zIndex = -1;
      } else {
        categoriRef.current.children[1].style.visibility = "visible";
        categoriRef.current.children[1].style.zIndex = 99;
      }
    }
  };

  const isTokenValid = () => {
    const token = getCookie("token");
    const loginUrl = "login";
    const mypageUrl = "mypage/order";

    if (!token) return setDecideUrl(loginUrl);
    else return setDecideUrl(mypageUrl);
  };

  //사용자 알림 처리
  const { isToggleActive, getPushStats, onClickToggleBtn } =
    useNotiSettingHandler({
      userInfo,
    });

  //토큰&로그인&로그아웃 처리
  const {
    userName,
    userCompanyName,
    authHandler,
    showBtnText,
    logoutConfirmHandler,
  } = useAuthHandler({ userInfo, openConfirmModal, setIsUser, setBtnText });

  // 메뉴 라우팅
  const buildPage = (pages) => {
    if (!pages) return;
    const temp = [...pages];

    // 시제품 판촉물 필터링
    const filteredPages = temp.map((page) => {
      if (page.sub) {
        return {
          ...page,
          sub: page.sub.filter((subPage) => {
            // 시제품 제작 메뉴는 siteConfig.Prototype이 null이 아닐 때만 표시
            if (subPage.url === "/customizing/prototype") {
              return siteInfo?.Prototype !== null;
            }
            if (subPage.url === "/customizing/promotion") {
              return siteInfo?.Promotion !== null;
            }
            return true;
          }),
        };
      }
      return page;
    });

    const menus = filteredPages.map((page, pageIdx) => {
      const isEventPage = page.url === "/event";
      const hasEvent =
        dummyList?.event !== undefined &&
        Array.isArray(dummyList.event.data) &&
        dummyList.event.data.length > 0;

      if (isEventPage && !hasEvent) {
        return null; // 이벤트가 없으면 메뉴 제외
      }

      if (!page.sub) {
        // 현재 경로에서 쿼리 제거
        const currentPath = router.asPath.split("?")[0];
        let targetPath = page.url.split("?")[0];

        // targetPath가 상대 경로라면 절대 경로로 변환
        if (!targetPath.startsWith("/")) {
          targetPath = "/" + targetPath;
        }

        // 슬래시(`/`)로 끝나지 않도록 처리하여 비교 시 일관성 유지
        targetPath = targetPath.replace(/\/$/, "");

        // 현재 경로가 targetPath로 시작하면 active 처리
        const isActive =
          currentPath === targetPath ||
          currentPath.startsWith(targetPath + "/");

        // 서브메뉴가 없는 일반 메뉴 처리
        if (page.url === "/group-purchase") {
          return (
            <li key={pageIdx}>
              <Link href={page.url}>
                <a className={isActive ? "active" : ""}>
                  <div className="position-relative">
                    <ProceedingMenuBadge siteInfo={siteInfo} />
                    {page.title}
                  </div>
                </a>
              </Link>
            </li>
          );
        } else {
          if (
            page.url === "/customizing/prototype" &&
            siteInfo?.Prototype === null
          ) {
            return null;
          }
          if (
            page.url === "/customizing/promotion" &&
            siteInfo?.Promotion === null
          ) {
            return null;
          }
          if (page.url === "/event" && siteInfo?.event === null) {
            return null;
          }
          return (
            <li key={pageIdx}>
              <Link href={page.url}>
                <a className={isActive ? "active" : ""}>{page.title}</a>
              </Link>
            </li>
          );
        }
      } else {
        // 맞춤제작 메뉴 특별 처리
        if (page.title === "맞춤제작") {
          // siteInfo.MakeCategory에서 데이터를 가져와 동적으로 구성
          const categories = siteInfo?.MakeCategory || [];
          const categoriesType = siteInfo?.MakeTypeCategory || [];

          // PageRouter에서 맞춤제작 관련 정적 메뉴 항목 찾기
          const customizingRouter = PageRouter.find(
            (route) => route.title === "맞춤제작"
          );

          // 하단 메뉴용 항목 (견적 바구니, 포트폴리오, 고객사)
          const bottomMenuItems = customizingRouter.sub;

          // 기타 메뉴 항목들 (시제품 제작, 판촉물 제작)
          const otherMenuItems = bottomMenuItems.filter((item) => {
            // siteInfo 값에 따라 필터링
            if (
              item.url === "/customizing/prototype" &&
              siteInfo?.Prototype === null
            ) {
              return false;
            }
            if (
              item.url === "/customizing/promotion" &&
              siteInfo?.Promotion === null
            ) {
              return false;
            }
            return true;
          });

          return (
            <MenuItemWithDropdown key={pageIdx}>
              <Link href={page.url || "#"}>
                <a
                  className={
                    page.sub.some(
                      (subItem) =>
                        router.asPath.includes(subItem.url) ||
                        (subItem.subCategories &&
                          subItem.subCategories.some((cat) =>
                            router.asPath.includes(cat.url)
                          ))
                    )
                      ? "active"
                      : ""
                  }
                >
                  {page.title}
                </a>
              </Link>

              <StyledMegaMenu
                $left={-142}
                $categoriesLength={categories.length}
              >
                <CategoryCustomizingMenu
                  dummyList={dummyList}
                  headerMenu={headerMenu}
                  categories={categories}
                  categoriesType={categoriesType}
                  otherMenuItems={otherMenuItems}
                />
              </StyledMegaMenu>
            </MenuItemWithDropdown>
          );
        } else {
          // 일반적인 서브메뉴가 있는 메뉴 처리
          return (
            <MenuItemWithDropdown key={pageIdx}>
              {page.url ? (
                <Link href={page.url}>
                  <a
                    className={
                      page.sub.some((subItem) =>
                        router.asPath.includes(subItem.url)
                      )
                        ? "active"
                        : ""
                    }
                  >
                    {page.title}
                  </a>
                </Link>
              ) : (
                <a
                  role="button"
                  className={
                    page.sub.some((subItem) =>
                      router.asPath.includes(subItem.url)
                    )
                      ? "active"
                      : ""
                  }
                >
                  {page.title}
                </a>
              )}

              <StyledMegaMenu
                $left={
                  page.title === "고객지원"
                    ? -760 // 고객지원 메뉴 위치 조정
                    : page.title === "ESG자료실"
                    ? -660 // ESG 메뉴 위치 조정
                    : -220 // 소량인쇄
                }
              >
                <CategoryMenu
                  page={page}
                  title={page.title}
                  img={
                    page.title === "고객지원"
                      ? lnbCsboard?.[0]?.P_FileUrl
                      : page.title === "ESG자료실"
                      ? lnbEsg?.[0]?.P_FileUrl
                      : lnbSmallPrint?.[0]?.P_FileUrl
                  }
                  url={
                    page.title === "고객지원"
                      ? lnbCsboard?.[0]?.link_url
                      : page.title === "ESG자료실"
                      ? lnbEsg?.[0]?.link_url
                      : lnbSmallPrint?.[0]?.link_url
                  }
                />
              </StyledMegaMenu>
            </MenuItemWithDropdown>
          );
        }
      }
    });

    return menus;
  };

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY >= 100;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });

    document.addEventListener("mouseover", hadleClickOutSide);
    return () => {
      document.removeEventListener("mouseover", hadleClickOutSide);
    };
  }, []);

  useEffect(() => {
    if (mainAward && mainAward.length > 0) {
      setTimeout(() => {
        if (awardIdx + 1 >= mainAward.length) {
          setAwardIdx(0);
          return;
        }
        setAwardIdx((prev) => prev + 1);
      }, 3000);
    }
  }, [bannerList, awardIdx]);

  useEffect(() => {
    getPushStats();
    isTokenValid();
    showBtnText();
  }, [userInfo]);

  useEffect(() => {
    if (!router.isReady) return;
    setMenus(buildPage(PageRouter));
    getCookie("token") && fetchBasketsAction();
    if (Object.keys(dummyList).length === 0) {
      fetchDummyList();
    }
    if (Object.keys(siteInfo).length === 0) {
      fetchSiteInfo(router);
    }
    if (typeof window !== "undefined" && "Notification" in window) {
      // 알림 허용 상태 변경 시 실행되는 함수
      const handlePermissionChange = () => {
        setNotificationPermission(Notification.permission);
      };

      // 알림 허용 상태 변경 이벤트를 감지하고 상태를 업데이트합니다.
      Notification.requestPermission().then(handlePermissionChange);
      window.addEventListener("change", handlePermissionChange);

      // 컴포넌트 언마운트 시 이벤트 리스너를 제거합니다.
      return () => {
        window.removeEventListener("change", handlePermissionChange);
      };
    }
  }, [router.isReady, dummyList, siteInfo]);

  const bannerCookie = getCookie(BANNER_COOKIE_NAME);

  return (
    <Suspense>
      <header className="header-area header-style-1 header-height-2">
        {/* 이미지 배너 또는 띠 배너 */}
        {isMobile ? (
          hasMainStripe && <StripeBanner banners={bannerList} />
        ) : bannerCookie ? (
          <StripeBanner banners={bannerList} />
        ) : (
          hasMainImageStripe && (
            <ImageBanner banners={bannerList} handleClose={handleClose} />
          )
        )}

        {/* 최상단 헤더 */}
        <FirstHeader
          logo={logo}
          banners={bannerList}
          awardIdx={awardIdx}
          scroll={scroll}
          openSearch={openSearch}
          setOpenSearch={setOpenSearch}
          scrollSearchBtnRef={scrollSearchBtnRef}
        />
        {/* 2번 헤더 */}
        <SecondHeader
          scroll={scroll}
          logo={logo}
          banners={bannerList}
          categoriRef={categoriRef}
          setToggled={setToggled}
          menus={menus}
          decideUrl={decideUrl}
          userName={userName}
          userCompanyName={userCompanyName}
          isUser={isUser}
          authHandler={authHandler}
          getCookie={getCookie}
          basketsCount={basketsCount}
          toggleClick={toggleClick}
          userInfo={userInfo}
          userCoupons={userCoupons}
          notificationPermission={notificationPermission}
          onClickToggleBtn={onClickToggleBtn}
          totalCartItems={totalCartItems}
          openSearch={openSearch}
          setOpenSearch={setOpenSearch}
          scrollSearchBtnRef={scrollSearchBtnRef}
          isToggleActive={isToggleActive}
        />
      </header>
      <MobileSearch
        searchToggled={searchToggled}
        onClickSearch={onClickSearch}
        dummyList={dummyList}
      />
      <UserFloating
        scroll={scroll}
        userInfo={userInfo}
        basketItems={basketItems}
        clearBasketsAction={clearBasketsAction}
        modifyConfirmModal={modifyConfirmModal}
        openConfirmModal={openConfirmModal}
        closeConfirmModal={closeConfirmModal}
        deleteBasketsAction={deleteBasketsAction}
        fetchBasketsAction={fetchBasketsAction}
        insertBasketsAction={insertBasketsAction}
        deleteFromCart={deleteFromCart}
        vp={vp}
        cartItems={cartItems}
        clearCart={clearCart}
        decreaseCnt={decreaseCnt}
        increaseCnt={increaseCnt}
        onClickSearch={onClickSearch}
        toggleClick={toggleClick}
      />
    </Suspense>
  );
};

const mapStateToProps = (state) => ({
  show: state.confirm.modal,
  totalCartItems: state.cart.length,
  cartItems: state.cart,
  basketItems: state.baskets.items,
  basketsCount: state.baskets.count,
  productFilters: state.productFilters,
  loading: state.loading.loading,
  // banners: state.banners,
  dummyList: state.dummyList,
  vp: state.vp,
  siteInfo: state.siteInfo,
});

const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  deleteBasketsAction,
  insertBasketsAction,
  fetchBasketsAction,
  clearBasketsAction,
  initBaskets,
  deleteFromCart,
  updateProductCategory,
  isLoaded,
  isLoading,
  fetchDummyList,
  clearCart,
  decreaseCnt,
  increaseCnt,
  fetchSiteInfo,
  initUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
